import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tree from 'react-d3-tree';
import { getDateValue } from '../../utils/date';

class PhaseChart extends React.Component {
  constructor(props, context) {
    super(props, context);
    
    this.state = {
      phaseData: this.getProjectSubway(),
    };
          
    this.handleClick = this.handleClick.bind(this);
  }

  getAllMethods(object) {
    return Object.getOwnPropertyNames(object).filter(function(property) {
      if(typeof object[property] === 'function') {
        console.log('function');
        console.log(object[property]);
      }
    });
  }

  handleClick(nodeObj, cont) {
    if (!cont || nodeObj._collapsed)
      return;
  }

  getProjectSubway(){
    const project = this.props.project;
    const phases = _.uniqBy(project.prjPhaseSubPhaseSubway, 'phase');
    const prjPhaseSubPhaseSubway = project.prjPhaseSubPhaseSubway;
    
    let phaseSubway=[];

    let parentObj = {
      name: project.projectId,
      nodeSvgShape: {
        shapeProps: {
          r: 3,
          fill: '#89828D',
        },
      }, children:[]
    }

    phaseSubway.push(parentObj);

    phases.map((ph,index) => {
      const phSubPh = prjPhaseSubPhaseSubway.filter(c=>c.phase === ph.phase)
      let filled='';
      let aPhDate=null;
      let sPhDate=null;
      if(phSubPh.length > 0) {
          let subway = phSubPh.filter(c=>c.subway === 'In Progress') ;
           if(subway.length > 0) {
              filled='#F4D03F';
           }
           else  {
              subway = phSubPh.filter(c=>c.subway === 'Future') ;

              if(subway.length > 0) {
                filled='#3598DC';
              }
              else {
               
                subway = phSubPh.filter(c=>c.subway === 'Completed') ;

                if(subway.length > 0) {
                  filled='#26C281';
                }
              }

            }
        }

        let child = {
            id: ph.phaseSequence,
            name: ph.phase,
            nodeSvgShape: {
            shapeProps: {
              r: 9,
              fill: filled,
            },
          },children:[]
          ,_collapsed: false
        };

        
        
        filled='';
        
        phSubPh.map((phsb,index) => {
          if(phsb.subway==='Completed')
            filled='#26C281';
          else if(phsb.subway==='In Progress')
            filled='#F4D03F';
          else if(phsb.subway==='Future')
            filled='#3598DC';

          if(project.contractProcModelList.length > 0 && project.contractProcModelList[0].procurementStatus !== null)
          {
              if(phsb.subPhase==='In Legal') {
                if(project.contractProcModelList[0].inLegalActualEnd != null) {
                  aPhDate=project.contractProcModelList[0].inLegalActualEnd;
                }
                else if(project.contractProcModelList[0].inLegalSchedEnd != null) {
                  sPhDate=project.contractProcModelList[0].inLegalSchedEnd;
                }
              }
              else if(phsb.subPhase==='Schedule Bid Advertisment' || phsb.subPhase==='Schedule Bid Advertisement') {
                if(project.contractProcModelList[0].schedBidActualEnd != null) {
                  aPhDate=project.contractProcModelList[0].schedBidActualEnd;
                }
                else if(project.contractProcModelList[0].schedBidSchedEnd != null) {
                  sPhDate=project.contractProcModelList[0].schedBidSchedEnd;
                }
              }
              else if(phsb.subPhase==='Bid Dates') {
                if(project.contractProcModelList[0].bidDatesActualEnd != null) {
                  aPhDate=project.contractProcModelList[0].bidDatesActualEnd;
                }
                else if(project.contractProcModelList[0].bidDatesSchedEnd != null) {
                  sPhDate=project.contractProcModelList[0].bidDatesSchedEnd;
                }
              }
              else if(phsb.subPhase==='Pre Award / APT') {
                if(project.contractProcModelList[0].preAwardSchedEnd != null) {
                  aPhDate=project.contractProcModelList[0].preAwardSchedEnd;
                }
                else if(project.contractProcModelList[0].preAwardActualEnd != null) {
                  sPhDate=project.contractProcModelList[0].preAwardActualEnd;
                }
              }
              else if(phsb.subPhase==='Award') {
                if(project.contractProcModelList[0].awardSchedEnd != null) {
                  aPhDate=project.contractProcModelList[0].awardSchedEnd;
                }
                else if(project.contractProcModelList[0].awardActualEnd != null) {
                  sPhDate=project.contractProcModelList[0].awardActualEnd;
                }
              }
              else if(phsb.subPhase==='Execution') {
                if(project.contractProcModelList[0].executionSchedEnd != null) {
                  aPhDate=project.contractProcModelList[0].executionSchedEnd;
                }
                else if(project.contractProcModelList[0].executionActualEnd != null) {
                  sPhDate=project.contractProcModelList[0].executionActualEnd;
                }
              }
              else if(phsb.subPhase==='Registration') {
                if(project.contractProcModelList[0].registrationActualEnd != null) {
                  aPhDate=project.contractProcModelList[0].registrationActualEnd;
                }
                else if(project.contractProcModelList[0].registrationSchedEnd != null) {
                  sPhDate=project.contractProcModelList[0].registrationSchedEnd;
                }
              }
              

          }

          let childchild = {
            id: phsb.subPhaseSequence,
            name: phsb.subPhase,
            nodeSvgShape: {
            shapeProps: {
              r: 6,
              fill: filled,
            },
          },
        };

        if(aPhDate != null){
          childchild.attributes= { a: getDateValue(aPhDate) };
        }
        else if(sPhDate != null){
          childchild.attributes= { s: getDateValue(sPhDate) };
        }

        child.children.push(childchild);
        });
      parentObj.children.push(child);
    });

    return phaseSubway;
  }

  render() {
    const phaseData = this.state.phaseData;

    return (
        <div className="phase-chart-outer-container">
          <div className="phase-chart-padding">
            <div id="phaseWrapper">

              <Tree data={phaseData} ref="myRef"
                initialDepth={1}
                orientation="vertical"
                pathFunc="elbow"
                translate={{ x: 575, y: 20 }}
                styles={{ links: { stroke: '#89828D', strokeWidth: 1 } }}
                nodeSize={{ x: 160, y: 50 }}
                zoomable={false}
                shouldCollapseNeighborNodes = {true}
                onClick={(nodeObj) => this.handleClick(nodeObj, true)}               
              />

            </div>
          </div>
        </div>
    );
  }
}

PhaseChart.propTypes = {
  project: PropTypes.object.isRequired
};

export default PhaseChart;